<template>
  <div class="area-wrap">
    <el-tree :props="props" :load="loadNode" :data="data" node-key="id" :empty-text="emptyText" lazy :highlight-current="true" :default-expanded-keys="defExpKeys" @node-expand="nodeExpand" @node-collapse="nodeCollapse" @node-click="nodeClick">
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div class="area-info">{{ node.label }}<span class="area-manager">{{ data.manager }}</span></div>
<!--        <div class="area-opt">-->
<!--          <el-tag size="mini" @click="(e) => editArea(e, {parent_id: data.id})"><i class="el-icon-plus"></i>添加</el-tag>-->
<!--          <el-tag size="mini" @click="(e) => editArea(e, data)"><i class="el-icon-edit"></i>编辑</el-tag>-->
<!--          <el-tag type="danger" size="mini" @click="(e) => removeArea(e, data)"><i class="el-icon-delete"></i>删除</el-tag>-->
<!--        </div>-->
      </div>
    </el-tree>
  </div>
</template>

<script>
import {Area} from "../common";

export default {
  name: "AreaTree",
  data(){
    return{
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      data: [],
      emptyText: '',
      defEmptyText: '暂无数据',
      defExpKeys: [],
    }
  },
  beforeMount() {
    this.resetForm()
  },
  created() {
    this.getAreaList()
  },
  methods:{
    search() {

    },
    getAreaList() {
      this.emptyText = '正在加载数据...'
      Area.getAreaList({parent_id: 0}, res => {
        this.emptyText = this.defEmptyText
        this.data = res.data
      })
    },
    editArea(e, data) {

      if(data) {
        this.form = Object.assign({}, this.defValue, data)
        this.getAreaFullName()
      } else {
        this.resetForm()
      }

      this.dialogVisible = true
      if(e) e.stopPropagation()
    },
    removeArea(e, data) {

      this.$confirm(`此操作将删除 [ ${data.name} ] 及其子区域，是否继续?`, '提示', {type: 'warning'}).then(() => {
        Area.deleteArea({id: data.id}, res => {
          this.message(res)
          if(res.code == 0) this.getAreaList()
        })
      })

      e.stopPropagation()
    },
    submit() {

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.saveArea()
        } else {
          return false;
        }
      });

    },
    resetForm() {
      this.form = Object.assign({}, this.defValue)
    },
    saveArea() {

      this.submitLoading = true
      let data = Object.assign({}, this.form)
      Area.saveArea(data, res => {
        this.submitLoading = false
        this.message(res)
        if(res.code == 0) {
          this.resetForm()
          this.dialogVisible = false
          this.getAreaList()
        }
      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },

    showAreaSelector() {
      this.areaSelectorVisible = true
    },

    areaSelected(data) {

      if(data.id == this.form.id) {
        this.$message.error('上级不能选择自己')
        return false
      }

      this.form.parent_id = data.id
      this.getAreaFullName()
    },

    getAreaFullName() {
      let that = this
      if(that.form.parent_id == '') return false
      Area.getAreaFullName({id: that.form.parent_id}, res => {

        that.form = Object.assign({}, that.form, {parent_name: res.data.join(' -> ')})
      })
    },

    loadNode(node, resolve) {
      if(node.data.id) {
        Area.getAreaList({parent_id: node.data.id}, res => {
          resolve(res.data)
        })
      }
    },

    nodeExpand(data, node, obj) {
      if(this.defExpKeys.includes(node.key) == false) {
        this.defExpKeys.push(node.key)
      }
    },

    nodeCollapse(data, node) {
      let k = this.defExpKeys.indexOf(node.key)
      if(k !== -1) this.defExpKeys.splice(k, 1)
    },
    nodeClick(data, node) {
      this.$emit('nodeClick', {
        level: node.level,
        type: node.data.type,
        id: node.data.id,
        name: node.data.name,
        tree:nodeToList(node)
      })
    }
  }
}
function nodeToList(node) {
  let node_list=[]
  node_list[10]=node.data;
  let nodeObj=node
  for(let i=9;i>0;i--){
    nodeObj['parent']&&(nodeObj=nodeObj['parent'],node_list[i]=nodeObj.data[0]?nodeObj.data[0]:nodeObj.data);
  }
  return node_list.filter(ret=>{return ret}).splice(1)
}
</script>

<style lang="scss" scoped>
@import '../common2.scss';

.area-dialog {

  .area-form {
    margin-right: 50px;
  }
}
.area-wrap {
  //margin-top: 15px;
  margin-right: 20px;
  width: 180px;
  border-right: 1px solid #ccc;
  padding: 5px;
  overflow: auto;
  height: calc( 100vh - 220px );
}

/deep/.custom-tree-node {
  flex: 1;
  display: flex;
  justify-content: space-between;

  .area-info {
    font-size: 14px;
  }

  .area-manager {
    padding-left: 5px;
    color: #999;
  }

  .area-opt {
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/AreaTree.vue